export function QueryStringToJSON(str='') {
    if(str == ''){
        str = window.location.search.slice(1)
    }
    var pairs = str.split('&');
    var result = {};
    pairs.forEach((pair) => {
        let pair_split = pair.split('=');
        result[pair_split[0]] = decodeURIComponent(pair_split[1] || '');
    });
    return JSON.parse(JSON.stringify(result));
}